import { Component, effect } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';

import { SimulationNewNetworkService, ParameterError } from '../simulation-new-network.service';
import {
    AlertModule,
    AlertService,
    ButtonModule,
    ButtonTypes,
    ButtonColors,
    LayerService,
    LayerSize,
    PopupModule,
} from '@ed---interne/ng-uui-components';
import { SharedModule } from '../../../../shared/shared.module';
import { DocumentService } from '../../../../core/services/document.service';

import { SimulateNewNetworkComponent } from '../modals/simulate-new-network/simulate-new-network.component';

@Component({
    selector: 'app-simulation-new-network',
    templateUrl: './simulation-new-network.component.html',
    styleUrl: './simulation-new-network.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        AlertModule,
        ButtonModule,
        PopupModule,
        SimulateNewNetworkComponent,
    ],
    providers: [DocumentService, Store],
})
export class SimulationNewNetworkComponent {
    public buttonColors = ButtonColors;
    public buttonTypes = ButtonTypes;

    public isUploading = false;

    public gpkgFile: File | null = null;
    public xlsxFile: File | null = null;

    public resetGpkgCounter = 0;
    public resetXlsxCounter = 0;

    public xlsxErrors: ParameterError[] = [];

    constructor(
        private simulationService: SimulationNewNetworkService,
        private readonly alertService: AlertService,
        private readonly layerService: LayerService,
    ) {
        effect(() => {
            this.resetGpkgCounter = this.simulationService.gpkgResetSignal();
            this.resetXlsxCounter = this.simulationService.xlsxResetSignal();
        });
    }

    get canRunSimulation() {
        return this.simulationService.canRunNewNetworkSimulation();
    }

    onGpkgFileUpload(file: File | null) {
        this.simulationService.setGpkgFile(file);
    }

    async onXlsxFileUpload(file: File | null) {
        if (!file) {
            this.simulationService.setXlsxFile(null);
            this.simulationService.clearProspectParams();
            return;
        }

        this.simulationService.setXlsxFile(file);
        this.xlsxErrors = await this.simulationService.extractApiFormatFromExcel(file);
    }

    public downloadTemplate(): void {
        this.alertService.valid('Document', `Le fichier excel a bien été téléchargé`);

        const link = document.createElement('a');
        link.href = 'assets/templates/Template paramètres simulation.xlsx';
        link.download = 'Template paramètres simulation.xlsx';
        link.click();
    }

    public openModalRunSimulation(): void {
        this.layerService.show(SimulateNewNetworkComponent, {
            size: LayerSize.Medium,
        });
    }
}
